import { BaseRouteReuseStrategy, Route } from '@angular/router';

/**
 * Route `data` key opting a route into `withExperimentalAutoCleanupInjectors()` teardown.
 * Set it on the route that owns route-scoped providers, e.g. `data: { [DESTROY_ROUTE_INJECTOR]: true }`.
 */
export const DESTROY_ROUTE_INJECTOR = 'destroyRouteInjector';

/**
 * Destroys a deactivated route's EnvironmentInjector only when the route opts in via
 * `DESTROY_ROUTE_INJECTOR`. The default strategy returns `true` for every route, which tears down
 * the NgRx `StoreModule.forFeature` modules our route `providers` import — their `ngOnDestroy`
 * removes the feature reducer, so the state slice vanishes while effects and root-provided facades
 * are still selecting from it.
 */
export class OptInRouteInjectorCleanupStrategy extends BaseRouteReuseStrategy {
  override shouldDestroyInjector(route: Route): boolean {
    return route.data?.[DESTROY_ROUTE_INJECTOR] === true;
  }
}
